import React, { Component, useState } from 'react'
import { withRouter } from '../../../utils/with-router'
import avatar from '../../Home/Speaker/speakers_avatars/avatar.svg'
import paul from '../../Home/Speaker/speakers_avatars/paul.svg'
import han from '../../Home/Speaker/speakers_avatars/han.svg'
import alan from '../../Home/Speaker/speakers_avatars/alan.svg'
import './Volunteers.css'
import { getVolunteers } from '../../../fetcher'

class  Volunteers extends Component {

    constructor(props) {
        super(props);
        this.state = {
        
          volunteersLists:[]
        
        };
      }

      componentDidMount() {
        this.fetchVolunteerData();
      }

      fetchVolunteerData = async () => {
        try {
          const memberData = await getVolunteers();
          let memberList=[]
          memberData.records.forEach((speakerContentElement, index) => {
            const speaker = memberData.records[index].fields;
            // console.log(speaker)
            let id = index
            let name = speaker.Name;
            let title = speaker.Title
            let year=speaker.Year
            let photo = han
            if(speaker.Photo){
                photo = speaker.PhotoTemp[0].url
            }
            let memberDetail = {id:id, name: name, title:title, year:year, photo: photo}
            memberList.push(memberDetail)
          });

          this.setState({volunteersLists: memberList})

        } catch (error) {
          console.error(error);
        }
      };


    render(){
        let MemberList = this.state.volunteersLists.map(item=>{
            return (
            <div className='volunteers-newList-one' key={item.id}>
             <div className='volunteers_speaker_content'>
                        <div className='volunteers_speaker_avatar_container'>
                            <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='volunteers_speaker_pic' src={item.photo} alt="pic" />
                        </div>
                        <h1 className='volunteers_speaker_name'>{item.name}</h1>
                        <h4 className='volunteers_speaker_position'>{item.title}</h4>
                        <h4 className='volunteers_speaker_company'>{item.year}</h4>
                    </div>
            </div>)
        })

        return(
            
        <div className = "VONLUNTEERS">
            <h2 class='panel_title'>Volunteers</h2>
                <div className='volunteers_speaker_container'>
                    {MemberList}
                    {/* <div className='volunteers_speaker_content'>
                        <div className='volunteers_speaker_avatar_container'>
                            <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                        </div>
                        <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                        <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                        <h4 className='volunteers_speaker_company'>@Box</h4>
                    </div>
                    <div className='volunteers_speaker_content'>
                        <div className='volunteers_speaker_avatar_container'>
                            <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='volunteers_speaker_pic_1' src={han} alt="pic" />
                        </div>
                        <h1 className='volunteers_speaker_name' left='-10px'>Han-Shen(Han) Yuan</h1>
                        <h4 className='volunteers_speaker_position'>EX-Senior VP of</h4>
                        <h4 className='volunteers_speaker_position'>Engineering</h4>
                        <h4 className='volunteers_speaker_company'>@Upwork</h4>
                    </div>
                    <div className='volunteers_speaker_content'>
                        <div className='volunteers_speaker_avatar_container'>
                            <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='volunteers_speaker_pic_1' src={alan} alt="pic" />
                        </div>
                        <h1 className='volunteers_speaker_name'>Alan Wang</h1>
                        <h4 className='volunteers_speaker_position'>Founder @Alan Wang</h4>
                        <h4 className='volunteers_speaker_company'>Realty Group</h4>
                    </div>
                </div>
            <div className='volunteers_speaker_container'>
                <div className='volunteers_speaker_content'>
                    <div className='volunteers_speaker_avatar_container'>
                        <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                    <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='volunteers_speaker_company'>@Box</h4>
                </div>
                <div className='volunteers_speaker_content'>
                    <div className='volunteers_speaker_avatar_container'>
                        <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                    <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='volunteers_speaker_company'>@Box</h4>
                </div>
                <div className='volunteers_speaker_content'>
                    <div className='volunteers_speaker_avatar_container'>
                        <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                    <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='volunteers_speaker_company'>@Box</h4>
                </div>
                
            </div>
            <div className='volunteers_speaker_container'>
                <div className='volunteers_speaker_content'>
                    <div className='volunteers_speaker_avatar_container'>
                        <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                    <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='volunteers_speaker_company'>@Box</h4>
                </div>
                <div className='volunteers_speaker_content'>
                    <div className='volunteers_speaker_avatar_container'>
                        <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                    <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='volunteers_speaker_company'>@Box</h4>
                </div>
                <div className='volunteers_speaker_content'>
                    <div className='volunteers_speaker_avatar_container'>
                        <img className='volunteers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='volunteers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='volunteers_speaker_name'>Paul Chapman</h1>
                    <h4 className='volunteers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='volunteers_speaker_company'>@Box</h4>
                </div>
                 */}
            </div>
            </div>
        )
    }
            
    }


    export default Volunteers;